import React from "react";
import Modal from "src/components/common/Modal";
import Button from "src/components/app/Button";

interface ConfirmationModalProps {
  show: boolean;
  handleClose: () => void;
  title: string;
  description?: string | React.ReactNode;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  handleClose,
  title,
  description,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Modal show={show} handleClose={handleClose} title={title}>
      <div className="relative space-y-4">
        <div className="flex flex-col items-center gap-5">
          <p className="text-sm text-gray-500">{description}</p>
        </div>

        <div className="flex items-center justify-between gap-5">
          <Button
            variant="outlined"
            onClick={handleClose}
            fullWidth
            loading={isLoading}
            disabled={isLoading}
            rounded="full"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            fullWidth
            loading={isLoading}
            disabled={isLoading}
            rounded="full"
          >
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
